// AuthService.js
import { useAxios } from '../utils/axiosConfig';
import config from '../contexts/ConfigContext'

const API_URL = config.API_AUTH_URL;
const SERVER_URL = config.SERVER_URL;
const API_PERMISSION_URL = config.API_PERMISSION_URL;
class AuthService {

  axios = useAxios();

  login(username: string, password: string) {
    //create a call with axios that contains username: username, password: password
    try 
    {
      return this.axios.post(SERVER_URL + '/api/login', { username, password }).then(response => {
        if (response.data.token) {
          localStorage.setItem('sso-auth', response.data.token);
          localStorage.setItem('sso-auth-expiration-date', response.data.expiration)
          localStorage.setItem('sso-auth-userId', response.data.profileId);
          localStorage.setItem('sso-auth-user', username);
        }
        return response.data;
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  getPermissions(functionalityCode: string | null) {
    try {
      let token = localStorage.getItem('sso-auth');
      let projectId = localStorage.getItem('projectId');
      const i18Lang= localStorage.getItem('i18nextLng');
      const localization = i18Lang ? i18Lang : 'en-EU';
      
      if (token) {
        return this.axios.get(`${API_PERMISSION_URL}/GetPermission?functionalityCode=${functionalityCode}`,
           { headers: 
              { 'Content-Type': 'application/json',
                'tokennetcore': token,
                'localization': localization,
                'projectId': projectId, 
              } 
            }).then(response => {
              return response;
            }).catch(error => {
              console.error(error);
              return error.response;
            });
            }
      else{
        // return error 401 unauthorized
        return { status: 401, data: { error: 'Unauthorized' }
      };
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async validate() {
      try {
        let token = localStorage.getItem('sso-auth');
        if (token) {
          let auth = await this.axios.post(`${API_URL}/ValidateToken?token=${token}`, { headers: { 'Content-Type': 'application/json' } });
          if(auth.status === 200)
            return auth.data.isValid;
          else
            return false;
        }
      }
      catch (error) {
        console.error(error);
        return false;
      }
    }
  }

export default AuthService;